import { Spinner } from "@xola/ui-kit";
import clsx from "clsx";
import React from "react";

interface LoaderProps {
    size?: string;
    className?: string;
    text?: string;
}

export const Loader = ({ size = "small", className = "", text = "" }: LoaderProps) => {
    return (
        <div className={clsx("ui-loader space-x-2 p-6 text-center", className)}>
            <Spinner size={size} />
            {text && <span>{text}</span>}
        </div>
    );
};
